import verifyTab from './components/verifyTab.vue';
import editPhone from './components/editPhone.vue';
import { checkAccountPassword, smsVerify, updatePasswordOrPhone } from './request';
import { mapState } from 'vuex';
export default {
  components: {
    verifyTab,
    editPhone
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visibleVerifyTab: true //验证tab
    };
  },
  computed: {
    visibleEditModal: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  mounted() {},
  methods: {
    confirmEditModal() {
      if (this.visibleVerifyTab) {
        // 第一步
        if (this.$refs.verifyRef.activeKey === '1') {
          this.$refs.verifyRef.$refs.ruleForm.validate(async valid => {
            if (valid) {
              var _this$accountInfo, _this$$refs$verifyRef;
              console.log('账号确认', this.$refs.verifyRef);
              let res = await checkAccountPassword({
                account: (_this$accountInfo = this.accountInfo) === null || _this$accountInfo === void 0 ? void 0 : _this$accountInfo.account,
                password: (_this$$refs$verifyRef = this.$refs.verifyRef.accountForm) === null || _this$$refs$verifyRef === void 0 ? void 0 : _this$$refs$verifyRef.password
              });
              if (res) {
                this.visibleVerifyTab = false;
                this.visibleEditPwd = true;
              }
            }
          });
        } else {
          this.$refs.verifyRef.$refs.mobileRuleForm.validate(async valid => {
            if (valid) {
              var _this$$refs$verifyRef2;
              console.log('手机号确认', this.$refs.verifyRef);
              let res = await smsVerify({
                mobile: this.accountInfo.globalRoaming + this.accountInfo.mobile,
                code: (_this$$refs$verifyRef2 = this.$refs.verifyRef.mobileForm) === null || _this$$refs$verifyRef2 === void 0 ? void 0 : _this$$refs$verifyRef2.code,
                way: 'updatePhone'
              });
              if (res) {
                this.visibleVerifyTab = false;
                this.visibleEditPwd = true;
              }
            }
          });
        }
      } else {
        // 修改手机号
        this.$refs.editPhoneRef.$refs.ruleForm.validate(async valid => {
          if (valid) {
            var _this$$refs$editPhone, _this$$refs$editPhone2;
            console.log('修改手机号', this.$refs.editPhoneRef);
            let res = await updatePasswordOrPhone({
              type: '2',
              // 1:修改密码 2:修改手机号
              globalRoaming: this.$refs.editPhoneRef.form.globalRoaming,
              mobile: (_this$$refs$editPhone = this.$refs.editPhoneRef.form) === null || _this$$refs$editPhone === void 0 ? void 0 : _this$$refs$editPhone.mobile,
              code: (_this$$refs$editPhone2 = this.$refs.editPhoneRef.form) === null || _this$$refs$editPhone2 === void 0 ? void 0 : _this$$refs$editPhone2.code
            });
            if (res) {
              // 重新获取用户信息
              this.visibleEditModal = false;
              this.visibleVerifyTab = true;
              await this.$store.dispatch('user/getInfo');
              this.$message.success(this.$t('手机号修改成功'));
              this.$emit('confirm', this.form);
            }
          }
        });
      }
    },
    cancleEditModal() {
      var _this$$refs;
      console.log('cancleEditModal', (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.verifyRef);
      this.visibleEditModal = false;
      this.visibleVerifyTab = true;
      this.visibleEditPwd = false;
      this.$refs.verifyRef.activeKey = '';
    }
  }
};